export default __webpack_public_path__ + "static/media/crowd-fund2.5db71404.jpg";